import { Outlet } from 'react-router-dom'
import { ModalProvider } from '@/contexts/ModalContext'
import { UserProvider } from '@/contexts/UserContext'
import { ShowProvider } from '@/contexts/ShowContext'
import { EpisodeProvider } from '@/contexts/EpisodeContext'
import { WebSocketProvider } from '@/contexts/WebSocketContext'
import { Toaster } from '@/components/ui/shadcn/sonner'

export default function RootLayout() {
  return (
    <UserProvider>
      <ShowProvider>
        <WebSocketProvider>
          <EpisodeProvider>
            <ModalProvider>
              <Outlet />
            </ModalProvider>
          </EpisodeProvider>
        </WebSocketProvider>
      </ShowProvider>
    </UserProvider>
  )
}

// Toaster is rendered outside providers since it doesn't need context
export function RootLayoutWithToaster() {
  return (
    <>
      <RootLayout />
      <Toaster />
    </>
  )
}
